import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  withStyles,
  ExpansionPanel,
  ExpansionPanelSummary,
  ExpansionPanelDetails,
  Typography,
  Tooltip,
  IconButton,
} from '@material-ui/core'
import { ExpandMore, Info } from '@material-ui/icons'
import classNames from 'classnames'
import styles from '../styles'
import { /* toggleActionTypePanel, */ pasteSnippet } from 'actions/template'
import { toggleActionTypePanel } from 'actions/tasks'
// import Snippets from './Snippets'
import Variables from '../Variables/Variables'
import language from 'utils/vast-languagepack'

export default connect(
  (state) => ({
    snippetsPanelExpanded: state.email.snippetsPanelExpanded,
    actionTypePanelExpanded: state.tasks.addOrEdit.actionTypePanelExpanded,
    variablesPanelExpanded: state.email.variablesPanelExpanded,
    sectionSelected: state.email.sectionSelected,
  }),
  (dispatch) =>
    bindActionCreators({ toggleActionTypePanel, pasteSnippet }, dispatch)
)(
  withStyles(styles)(
    ({
      classes,
      snippetsPanelExpanded,
      toggleActionTypePanel,
      pasteSnippet,
      actionTypePanelExpanded,
      variablesPanelExpanded,
      sectionSelected,
    }) =>
      sectionSelected !== null ? (
        <ExpansionPanel
          className='ignore-react-onclickoutside'
          style={
            actionTypePanelExpanded
              ? { borderRadius: 35, overflow: 'hidden' }
              : !Boolean(actionTypePanelExpanded) && snippetsPanelExpanded
              ? {
                  borderRadius: 35,
                  overflow: 'hidden',
                }
              : !Boolean(actionTypePanelExpanded) && !snippetsPanelExpanded
              ? {
                  borderTopLeftRadius: 35,
                  borderTopRightRadius: 35,
                  borderBottomLeftRadius: 0,
                  borderBottomRightRadius: 0,
                  overflow: 'hidden',
                }
              : null
          }
          expanded={Boolean(actionTypePanelExpanded)}
        >
          <ExpansionPanelSummary
            classes={{
              root: classes.expansionPanelGreen,
              expandIcon: classes.expandIcon,
            }}
            expandIcon={<ExpandMore />}
            onClick={() => toggleActionTypePanel()}
          >
            <Typography className={classes.heading}>EDITOR</Typography>
            <Tooltip
              title={
                language.templatePage.templateFormPage.toolTips.snippetToolTips
              }
            >
              <IconButton
                disableRipple
                style={{ padding: 0 }}
                className={classNames(classes.headingIcon, classes.color)}
              >
                <Info className={classes.icon} />
              </IconButton>
            </Tooltip>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.expansionPanelDetails}>
            <Variables />
          </ExpansionPanelDetails>
        </ExpansionPanel>
      ) : null
  )
);
